import { defineMessages, useIntl } from "react-intl";
import { useTheme } from "styled-components";
import { AuthorizationVerifier } from "../../components/authorization-verifier";
import { SECTION } from "../../lib/constants";
import { CONTRACT_STATUS } from "../../modules/witadmin/Common/constants";
import { MenuItem } from "./menu-elements";
import { NavMenu } from "./navMenu";

const messages = defineMessages({
  users: {
    id: "internalmenu.users",
    defaultMessage: "Users",
  },
  usersList: {
    id: "internalmenu.users.list",
    defaultMessage: "Listings",
  },
  usersCreate: {
    id: "internalmenu.users.create",
    defaultMessage: "Add new",
  },
  usersBatchCreate: {
    id: "internalmenu.users.batchCreate",
    defaultMessage: "Create by excel",
  },
  usersBatchEdit: {
    id: "internalmenu.users.batchEdit",
    defaultMessage: "Edit by excel",
  },
  usersBatchDelete: {
    id: "internalmenu.users.batchDelete",
    defaultMessage: "Delete by excel",
  },
  usersCreateCentral: {
    id: "internalmenu.users.createCentral",
    defaultMessage: "Create new central user",
  },
  usersAssignPermissions: {
    id: "internalmenu.users.assignPermissions",
    defaultMessage: "Assign permissions to engines",
  },
  usersChangeCentralPassword: {
    id: "internalmenu.users.changeCentralPassword",
    defaultMessage: "Change Password central DB",
  },
  usersChangeUserGroup: {
    id: "internalmenu.users.changeUserGroup",
    defaultMessage: "Change core user group",
  },
  usersReplicatePropertyInDevel: {
    id: "internalmenu.users.replicatePropertyInDevel",
    defaultMessage: "Replicate BD in Devel",
  },
  usersConnectionsWitchannel: {
    id: "internalmenu.users.connectionsWitchannel",
    defaultMessage: "Connections Witchannel",
  },
  usersJavaPropertiesToExcel: {
    id: "internalmenu.users.javaPropertiesToExcel",
    defaultMessage: "Java Properties to Excel (Imp & Exp)",
  },
  usersGoogleHotelFinder: {
    id: "internalmenu.users.googleHotelFinder",
    defaultMessage: "Admin Google Hotel Finder",
  },
  usersQueryAllProperties: {
    id: "internalmenu.users.queryAllProperties",
    defaultMessage: "Query all properties",
  },
  usersEmailListings: {
    id: "internalmenu.users.emailListings",
    defaultMessage: "Email Listings",
  },
  integrations: {
    id: "internalmenu.integrations",
    defaultMessage: "Integrations",
  },
  loyalty: {
    id: "internalmenu.loyalty",
    defaultMessage: "Loyalty",
  },
  importLoyaltyUsers: {
    id: "internalmenu.importLoyaltyUsers",
    defaultMessage: "Import users",
  },
  removeLoyaltyUsers: {
    id: "internalmenu.removeLoyaltyUsers",
    defaultMessage: "Remove users",
  },
  integrationsSiteminder: {
    id: "internalmenu.integrations.siteminder",
    defaultMessage: "Siteminder",
  },
  integrationsTripAdvisorRE: {
    id: "internalmenu.integrations.tripAdvisorRE",
    defaultMessage: "TripAdvisor Review Express",
  },
  integrationsRategain: {
    id: "internalmenu.integrations.rategain",
    defaultMessage: "Rategain",
  },
  integrationsParityRate: {
    id: "internalmenu.integrations.parityRate",
    defaultMessage: "Parity Rate",
  },
  integrationsGeneralParameters: {
    id: "internalmenu.integrations.generalParameters",
    defaultMessage: "General Parameters",
  },
  integrationsConfigurationManager: {
    id: "internalmenu.integrations.configurationManager",
    defaultMessage: "Configuration Manager",
  },
  integrationsChannelLogs: {
    id: "internalmenu.integrations.channelLogs",
    defaultMessage: "Channel reservation logs",
  },
  integrationsForwardingReservations: {
    id: "internalmenu.integrations.forwardingReservations",
    defaultMessage: "Forwarding Reservations",
  },
  integrationsQueryExecutor: {
    id: "internalmenu.integrations.queryExecutor",
    defaultMessage: "Query executor",
  },
  integrationsChannelManager: {
    id: "internalmenu.integrations.channelManager",
    defaultMessage: "Configure channels",
  },
  integrationsChain: {
    id: "internalmenu.integrations.chain",
    defaultMessage: "Configure chains",
  },
  integrationsBrandManager: {
    id: "internalmenu.integrations.brandManager",
    defaultMessage: "Brand Manager",
  },
  integrationsGoogleFeed: {
    id: "internalmenu.integrations.googleFeed",
    defaultMessage: "Google Feed",
  },
  integrationsDiscrepancies: {
    id: "internalmenu.integrations.discrepancies",
    defaultMessage: "discrepancies",
  },
  userAccessRightsFinder: {
    id: "internalmenu.integrations.userAccessRightsFinder",
    defaultMessage: "userAccessRightsFinder",
  },
  userPropertiesManager: {
    id: "internalmenu.integrations.userPropertiesManager",
    defaultMessage: "User Linked Properties Viewer",
  },
  integrationsAriSnapshot: {
    id: "internalmenu.integrations.ariSnapshot",
    defaultMessage: "Ari Snapshot",
  },
  crm: {
    id: "internalmenu.crmOld",
    defaultMessage: "CRM Old",
  },
  crmContracts: {
    id: "internalmenu.crm.contracts",
    defaultMessage: "Contracts",
  },
  crmContractsInForce: {
    id: "internalmenu.crm.contractsInForce",
    defaultMessage: "Contracts in force",
  },
  crmEditContract: {
    id: "internalmenu.crm.editContract",
    defaultMessage: "Edit contract",
  },
  crmBeta: {
    id: "internalmenu.crm",
    defaultMessage: "CRM",
  },
  crmBetaMarketingManager: {
    id: "internalmenu.crmBeta.marketingManager",
    defaultMessage: "Marketing Manager",
  },
  crmBetaClients: {
    id: "internalmenu.crmBeta.clients",
    defaultMessage: "Clients",
  },
  crmBetaProperties: {
    id: "internalmenu.crmBeta.properties",
    defaultMessage: "Properties",
  },
  crmBetaServices: {
    id: "internalmenu.crmBeta.services",
    defaultMessage: "Services",
  },
  crmBetaContracts: {
    id: "internalmenu.crmBeta.contracts",
    defaultMessage: "Contracts",
  },
  crmBetaPartners: {
    id: "internalmenu.crmBeta.partners",
    defaultMessage: "Partners",
  },
  crmBetaGenerate: {
    id: "internalmenu.crmBeta.generateBillingReport",
    defaultMessage: "Generate billing report",
  },
  crmBetaExtendedBillingReport: {
    id: "internalmenu.crmBeta.extendedBillingReport",
    defaultMessage: "Extended billing report",
  },
  crmBetaBillingReportSepteo: {
    id: "internalmenu.crmBeta.billingReportSepteo",
    defaultMessage: "MyS billing report",
  },
  utilities: {
    id: "internalmenu.utilities",
    defaultMessage: "Utilities",
  },
  utilitiesParameterization: {
    id: "internalmenu.utilities.parameterization",
    defaultMessage: "Parameterization",
  },
  utilitiesCheckInventoryIntegrity: {
    id: "internalmenu.utilities.checkInventoryIntegrity",
    defaultMessage: "Check Inventory Integrity",
  },
  utilitiesCompareDatabase: {
    id: "internalmenu.utilities.compareDatabase",
    defaultMessage: "Compare database",
  },
  adminControlPanel: {
    id: "internalmenu.adminControlPanel",
    defaultMessage: "Admin Control Panel",
  },
  adminControlPanelStatistics: {
    id: "internalmenu.adminControlPanel.statistics",
    defaultMessage: "Statistics for partners",
  },
  adminControlPanelReservationEvolution: {
    id: "internalmenu.adminControlPanel.reservationEvolution",
    defaultMessage: "Reservations and turnover evolution",
  },
  integrationsTaxConfiguration: {
    id: "internalmenu.integrations.taxConfiguration",
    defaultMessage: "Tax configuration",
  },
  loyaltyLinksGenerator: {
    id: "internalmenu.integrations.loyaltyLinksGenerator",
    defaultMessage: "Loyalty links generator",
  },
  propertyCalendarRegen: {
    id: "internalmenu.utilities.propertyCalendarRegen",
    defaultMessage: "Regen property calendar",
  },
  migrateReservation: {
    id: "internalmenu.utilities.migrateReservation",
    defaultMessage: "Migrate Reservation",
  },
  gtmManager: {
    id: "internalmenu.utilities.gtmManager",
    defaultMessage: "GTM Manager",
  },
  emailBlacklist: {
    id: "internalmenu.utilities.emailBlacklist",
    defaultMessage: "Email Blacklist",
  },
  upgradeManager: {
    id: "internalmenu.utilities.upgradeManager",
    defaultMessage: "Upgrade Manager",
  },
  guestAssistantSimulator: {
    id: "internalmenu.utilities.guestAssistantSimulator",
    defaultMessage: "Guest Assistant Simulator",
  },
  integrationsCampingMap: {
    id: "internalmenu.integrations.campingMap",
    defaultMessage: "Camping Map",
  },
  integrationsCampingMapping: {
    id: "internalmenu.integrations.campingMapping",
    defaultMessage: "Camping Mapping",
  },
});

interface InternalMenuProps {
  propertyTicker?: string;
}

export function InternalMenu({ propertyTicker }: InternalMenuProps) {
  const intl = useIntl();
  const defaultTicker = propertyTicker || "hoteldemo.com.v6";
  const theme = useTheme();
  return (
    <div className={`flex h-5 pt-3 gap-[20px] text-${theme.textColor}`}>
      {/* Users */}
      <AuthorizationVerifier section={SECTION.MAIN_USERS} showForbiddenMessage={false}>
        <NavMenu title={intl.formatMessage(messages.users)} section={SECTION.MAIN_USERS}>
          <div
            id="menuUsers"
            className="z-10 fixed bg-white divide-y divide-gray-100 rounded-lg shadow  ">
            <ul className="p-3 text-sm mb-0" aria-labelledby="dropdownNavbarButton">
              <MenuItem
                message={messages.usersBatchCreate}
                href={`/v6/ng/internal/user-manager/create`}
                section={SECTION.CREATE_USER_BATCH}
              />
              <MenuItem
                message={messages.usersBatchEdit}
                href={`/v6/ng/internal/user-manager/edit`}
                section={SECTION.EDIT_USER_BATCH}
              />
              <MenuItem
                message={messages.usersBatchDelete}
                href={`/v6/ng/internal/user-manager/delete`}
                section={SECTION.PROPERTY_CHANNEL_MANAGERS}
              />
              <MenuItem
                message={messages.usersCreate}
                href={`/v6/ng/internal/user-manager/create-property`}
                section={SECTION.CREATE_PROPERTY}
              />
              <MenuItem
                message={messages.usersReplicatePropertyInDevel}
                href={`/v6/ng/internal/user-manager/replicate-property`}
                section={SECTION.REPLICATE_PROPERTY}
              />
            </ul>
          </div>
        </NavMenu>
      </AuthorizationVerifier>

      {/* Integrations */}
      <AuthorizationVerifier
        section={SECTION.MAIN_INTERNAL_INTEGRATIONS}
        showForbiddenMessage={false}>
        <NavMenu
          title={intl.formatMessage(messages.integrations)}
          section={SECTION.MAIN_INTERNAL_INTEGRATIONS}>
          <div
            id="menuIntegrations"
            className="z-10 fixed bg-white divide-y divide-gray-100 rounded-lg shadow  ">
            <ul className="p-3 text-sm mb-0" aria-labelledby="dropdownNavbarButton">
              {propertyTicker && (
                <MenuItem
                  message={messages.integrationsConfigurationManager}
                  href={`/v6/ng/${propertyTicker}/configurationManager`}
                  section={SECTION.PROPERTY_CONFIGURATION}
                />
              )}
              <MenuItem
                message={messages.integrationsChannelLogs}
                href={`/v6/ng/internal/channelReservationLog`}
                section={SECTION.CHANNEL_LOGS}
              />
              <MenuItem
                message={messages.integrationsForwardingReservations}
                href={`/v6/ng/internal/forwardingReservations`}
                section={SECTION.RESEND_RESERVATION_TO_CHANNEL}
              />
              <MenuItem
                message={messages.integrationsGoogleFeed}
                href={`/v6/ng/internal/googleFeed`}
                section={SECTION.GOOGLE_FEED}
              />
              <MenuItem
                message={messages.integrationsQueryExecutor}
                href={`/v6/ng/internal/queryExecutor`}
                section={SECTION.QUERY_EXECUTOR}
              />
              <MenuItem
                message={messages.integrationsChannelManager}
                href={`/v6/ng/internal/channelManager`}
                section={SECTION.PROPERTY_CHANNEL_MANAGERS}
              />
              <MenuItem
                message={messages.integrationsChain}
                href={`/v6/ng/internal/chain`}
                section={SECTION.CHAIN_CONFIGURER}
              />
              <MenuItem
                message={messages.integrationsDiscrepancies}
                href={`/v6/ng/internal/discrepancies`}
                section={SECTION.CHAIN_CONFIGURER}
              />
              <MenuItem
                message={messages.userPropertiesManager}
                href={`/v6/ng/internal/user-properties-manager`}
                section={SECTION.USER_PROPERTIES_MANAGER}
              />
              <MenuItem
                message={messages.userAccessRightsFinder}
                href={`/v6/ng/internal/user-access-rights-finder`}
                section={SECTION.PROPERTY_CHANNEL_MANAGERS}
              />
              {propertyTicker && (
                <MenuItem
                  message={messages.integrationsTaxConfiguration}
                  href={`/v6/ng/${propertyTicker}/tax-configuration`}
                  section={SECTION.TAX_CONFIGURATION}
                />
              )}
              <MenuItem
                message={messages.loyaltyLinksGenerator}
                href={`/v6/ng/${propertyTicker}/loyalty-links-generator`}
                section={SECTION.LOYALTY_LINKS_GENERATOR}
              />
              <MenuItem
                message={messages.integrationsAriSnapshot}
                href={`/v6/ng/internal/ari-snapshot`}
                section={SECTION.ARI_SNAPSHOT}
              />
              <MenuItem
                message={messages.propertyCalendarRegen}
                href={`/v6/ng/internal/property-calendar-regen`}
                section={SECTION.PROPERTY_CALENDAR_REGEN}
              />
              <MenuItem
                message={messages.migrateReservation}
                href={`/v6/ng/internal/migrate-reservation`}
                section={SECTION.MIGRATE_RESERVATION}
              />
              <MenuItem
                message={messages.gtmManager}
                href={`/v6/ng/${propertyTicker}/gtm-manager`}
                section={SECTION.GTM_MANAGER}
              />
              <MenuItem
                message={messages.emailBlacklist}
                href={`/v6/ng/${propertyTicker}/email-blacklist`}
                section={SECTION.EMAIL_BLACKLIST}
              />
              <MenuItem
                message={messages.upgradeManager}
                href={`/v6/ng/${propertyTicker}/upgrade-manager`}
                section={SECTION.UPGRADE_MANAGER}
              />
              <MenuItem
                message={messages.guestAssistantSimulator}
                href={`/v6/ng/${propertyTicker}/guest-assistant-simulator`}
                section={SECTION.UPGRADE_MANAGER}
              />
              <MenuItem
                message={messages.integrationsCampingMap}
                href={`/v6/ng/${propertyTicker}/campingMap`}
                section={SECTION.CAMPING_MAP}
              />
              <MenuItem
                message={messages.integrationsCampingMapping}
                href={`/v6/ng/${defaultTicker}/integrations/camping-mapping`}
                section={SECTION.CAMPING_MAPPING_MANAGER}
              />
            </ul>
          </div>
        </NavMenu>
      </AuthorizationVerifier>

      {/* CRM (beta) */}
      <AuthorizationVerifier section={SECTION.MAIN_CRM} showForbiddenMessage={false}>
        <NavMenu
          title={intl.formatMessage(messages.crmBeta)}
          section={SECTION.MAIN_CRM}
          routes={[
            "/crm/clients",
            "/crm/properties",
            "/crm/services",
            "/crm/contracts",
            "/crm/partners",
            "/crm/generate",
            "/crm/marketing",
          ]}>
          <div
            id="menuCrmBeta"
            className="z-10 fixed bg-white divide-y divide-gray-100 rounded-lg shadow  ">
            <ul className="p-3 text-sm mb-0" aria-labelledby="dropdownNavbarButton">
              <MenuItem
                message={messages.crmBetaClients}
                route="/crm/clients?act=true"
                section={SECTION.CRM_CLIENT}
              />
              <MenuItem
                message={messages.crmBetaProperties}
                route="/crm/properties"
                section={SECTION.CRM_PROPERTY}
              />
              <MenuItem
                message={messages.crmBetaServices}
                route="/crm/services"
                section={SECTION.CRM_SERVICE}
              />
              <MenuItem
                message={messages.crmBetaContracts}
                route={`/crm/contracts?status=${CONTRACT_STATUS.LIVE}`}
                section={SECTION.CRM_CONTRACT}
              />
              <MenuItem
                message={messages.crmBetaPartners}
                route="/crm/partners"
                section={SECTION.CRM_PARTNER}
              />
              <MenuItem
                message={messages.crmBetaMarketingManager}
                route="/crm/marketing"
                section={SECTION.MARKETING_MANAGER}
                witAdminRequired={true}
              />
              <MenuItem
                message={messages.crmBetaGenerate}
                route="/crm/generate"
                section={SECTION.GENERATE_BILLING_REPORT}
              />
              <MenuItem
                message={messages.crmBetaExtendedBillingReport}
                href={`/v6/ng/${defaultTicker}/billing-report`}
                section={SECTION.CRM_BILLING_REPORT}
              />
              <MenuItem
                message={messages.crmBetaBillingReportSepteo}
                href={`/v6/ng/${defaultTicker}/billing-report-septeo`}
                section={SECTION.CRM_BILLING_REPORT}
              />
            </ul>
          </div>
        </NavMenu>
      </AuthorizationVerifier>

      {/* Admin Control Panel */}
      <AuthorizationVerifier
        section={SECTION.MAIN_ADMIN_CONTROL_PANEL}
        showForbiddenMessage={false}>
        <NavMenu
          title={intl.formatMessage(messages.adminControlPanel)}
          section={SECTION.SYSTEM_CONTROL_PANEL}>
          <div
            id="menuAdminControlPanel"
            className="z-10 fixed bg-white divide-y divide-gray-100 rounded-lg shadow  ">
            <ul className="p-3 text-sm mb-0" aria-labelledby="dropdownNavbarButton">
              <MenuItem
                message={messages.adminControlPanelStatistics}
                href={`/v6/select/${defaultTicker}/admin/sistema/SControlPanel`}
                section={SECTION.SYSTEM_CONTROL_PANEL}
              />
              <MenuItem
                message={messages.adminControlPanelReservationEvolution}
                href={`/v6/select/${defaultTicker}/admin/sistema/SControlClientes/evolucionfacturacion`}
                section={SECTION.BILLING_EVOLUTION}
              />
            </ul>
          </div>
        </NavMenu>
      </AuthorizationVerifier>

      {/* Integrations */}
      <AuthorizationVerifier
        section={SECTION.MAIN_INTERNAL_INTEGRATIONS}
        showForbiddenMessage={false}>
        <NavMenu
          title={intl.formatMessage(messages.loyalty)}
          section={SECTION.MAIN_INTERNAL_INTEGRATIONS}>
          <div
            id="menuIntegrations"
            className="z-10 fixed bg-white divide-y divide-gray-100 rounded-lg shadow  ">
            <ul className="p-3 text-sm mb-0" aria-labelledby="dropdownNavbarButton">
              <MenuItem
                message={messages.importLoyaltyUsers}
                href={`/v6/ng/${propertyTicker}/loyalty-customer-manager/import`}
                section={SECTION.SITEMINDER_SETTINGS}
              />
              <MenuItem
                message={messages.removeLoyaltyUsers}
                href={`/v6/ng/internal/loyalty-customer-manager/remove`}
                section={SECTION.TRIPADVISOR_RE_SETTINGS}
              />
            </ul>
          </div>
        </NavMenu>
      </AuthorizationVerifier>
    </div>
  );
}
